module.exports = __webpack_public_path__ + "static/img/CrowdScout.781345d.png";